import { HttpLink } from "@apollo/client/core";
import { config } from "@/shared/utils/config";

export const httpLink = new HttpLink({
  uri: config.httpGqlServerUrl,
});
